import { render, staticRenderFns } from "./item-order-template.vue?vue&type=template&id=43a4b485&scoped=true"
import script from "./item-order-template.vue?vue&type=script&lang=js"
export * from "./item-order-template.vue?vue&type=script&lang=js"
import style0 from "./item-order-template.vue?vue&type=style&index=0&id=43a4b485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7sjryms56nihpddmmbru7sns3m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a4b485",
  null
  
)

export default component.exports